export const PIE_CHART_HEIGHT = "700px";

export const buildTitle = (displayText) => {
  return {
    text: displayText,
    fontFamily: "Lato",
    fontWeight: "bold",
    textAlign: "left",
  };
};

export const buildSubTitle = (displayText) => {
  return {
    text: displayText,
    fontFamily: "Lato",
    fontWeight: "light",
    textAlign: "left",
    fontSize: "16px",
  };
};

export const buildSourceCaption = () => {
  return {
    text: `Data Provided By CAVU`,
    fontFamily: "Lato",
    fontWeight: "thin",
    paddingTop: 10,
    paddingRight: 10,
  };
};

export const buildLegendTable = (opts = {}) => {
  let layout = null;

  /* ensure that the legend box never gets too wide */
  if (opts.legendItemCount) {
    switch (opts.legendItemCount) {
      case 4:
      case 5:
      case 6:
        layout = "2x3";
        break;
      case 7:
      case 8:
      case 9:
        layout = "3x3";
        break;
      case 10:
      case 11:
      case 12:
        layout = "4x3";
        break;
      case 13:
      case 14:
      case 15:
        layout = "5x3";
        break;
      case 16:
      case 17:
      case 18:
        layout = "6x3";
        break;
    }
  }

  return {
    header: {
      text: "Legend",
    },
    overflow: "scroll",
    draggable: false,
    highlightPlot: true,
    minimize: false,
    maxItems: opts?.maxItems || 12,
    align: "center",
    verticalAlign: "bottom",
    marginBottom: 25,
    layout: opts?.layout || layout,
    tooltip: opts?.tooltip || null,
  };
};

export const buildGUIDisplay = () => {
  return {
    watermark: {
      position: "bl" //br (default - bottom-right), bl (bottom-left), tr (top-right), tl (top-left)
    },
    behaviors: [
      {
        id: "SaveAsImage",
        enabled: "none",
      },
      {
        id: "Reload",
        enabled: "none",
      },
      {
        id: "DownloadPDF",
        enabled: "all",
      },
      {
        id: "DownloadSVG",
        enabled: "none",
      },
      {
        id: "DownloadCSV",
        enabled: "none",
      },
      {
        id: "DownloadXLS",
        enabled: "none",
      },
      {
        id: "ViewDataTable",
        enabled: "none",
      },
      {
        id: "ViewSource",
        enabled: "none",
      },
    ],
  };
};

export const buildLabels = (categories = [], buildTierPies = false) => {
  const splitter = categories.map((cat) => {
    const split = cat.split("-");
    return split.length == 1 ? split[0] : split[1];
  });

  const county = splitter[0] || "";
  const state = splitter[1] || "";
  const type = splitter[2] || "";
  let pieTitles = [
    `All Entities in ${county}`,
    `All Entities in ${state}`,
    `All ${type} Entities in ${county}`,
    `All ${type}<br/>Entities in ${state}`,
  ];

  if (buildTierPies) {
    pieTitles = [
      "Tier 1",
      "Tier 2",
      "Tier 3",
      "Tier 4",
    ];
  }

  return [
    {
      fontSize: "16px",
      text: pieTitles[0],
      x: "4%",
      y: 75,
      width: "20%",
      wrapText: true,
      fontWeight: "bold",
    },
    {
      fontSize: "16px",
      text: pieTitles[1],
      x: "29%",
      y: 75,
      width: "20%",
      wrapText: true,
      fontWeight: "bold",
    },
    {
      fontSize: "16px",
      text: pieTitles[2],
      x: "54%",
      y: 75,
      width: "20%",
      wrapText: true,
      fontWeight: "bold",
    },
    {
      fontSize: "16px",
      text: pieTitles[3],
      x: "79%",
      y: 75,
      width: "20%",
      wrapText: true,
      fontWeight: "bold",
    },
  ];
};

export const buildScale = (type) => {
  if (type == "pies") {
    return {
      layout: "1x4",
      x: "1%",
      y: "5%",
      sizeFactor: 0.9, //0.9,
    };
  }
  return {};
};

// chartType "pie" | "bar" | "premium"
export const buildPlot = (chartType = "pie") => {
  const ToolTipObj = {
    text: "%t",
    fontColor: "#fff",
    fontWeight: "bold",
    fontFamily: "Lato",
    textAlpha: 1,
    backgroundColor: "#000",
    borderColor: "#000",
    alpha: 0.5,
    borderRadius: "10px",
    padding: "10%",
  };

  const AnimationObj = {
    onLegendToggle: true,
    effect: "ANIMATION_EXPAND_VERTICAL",
    method: "ANIMATION_LINEAR",
    sequence: "ANIMATION_BY_PLOT",
    speed: 500,
  };

  const HighlightObj = {
    backgroundColor: "#3d3d3d",
    borderWidth: 1,
    borderColor: "#000000",
  };

  const PieValueBox = {
    fontSize: 12,
    fontWeight: "bold",
    placement: "in",
    offsetR: "-10%",
  };

  const BarValueBox = {
    fontSize: 12,
    fontWeight: "bold",
    placement: "middle",
    color: "#fff",
    offsetR: "10%",
    text: "%v%",
    angle: -90,
    backgroundColor: "#000",
    borderRadius: "10px",
    paddingLeft: "12px",
    paddingRight: "12px",
  };

  const PremiumValueBox = {
    fontSize: 12,
    fontWeight: "bold",
    placement: "middle",
    color: "#fff",
    text: "$%v",
    angle: 0,
    backgroundColor: "#000",
    borderRadius: "10px",
    paddingLeft: "12px",
    paddingRight: "12px",
  };

  let ValueBox = chartType == "pie" ? PieValueBox : BarValueBox;
  if (chartType == "premium") {
    ValueBox = PremiumValueBox;
  }
  return {
    tooltip: ToolTipObj,
    animation: AnimationObj,
    highlightState: HighlightObj,
    valueBox: ValueBox,
    stacked: chartType == "bar",
  };
};
